export const UPDATE_BUSINESS_MUTATION = gql`
    mutation updateBusiness($id: Int!, $input: UpdateBusinessInput!) {
        updateBusiness(id: $id, input: $input) {
            id
            status
        }
    }
`;
